export enum PREFIX {
  PARTNERS = 'partners',
  PAYROLLLOAN = 'payrollloan',
}

export enum VERSION {
  V1 = 'v1',
  V2 = 'v2',
}

export enum SYSTEM_TYPE {
  NONE = 'NONE',
  PARTNERS = 'PARTNERS',
  BARICONSIG = 'BARICONSIG',
}
